import React, { useState, useContext } from "react";
import { Tab, Nav, Container, Row, Col, Button, Form } from "react-bootstrap";
import GoogleAdsScripts from "./GoogleAdsScripts";
import DataPulseScripts from "./DataPulseScripts";
import { SettingsContext } from './AccountSettingsButton'

export default function Scripts() {
	let exclaimTriangle = require("images/icons/exclaim-triangle.png");
	exclaimTriangle = <img className="mr-md-3 mr-0" width="25" height="23" src={`/datapulse${exclaimTriangle}`} />;

  const props = useContext(SettingsContext);

  const googleAdsScripts = [
    {
      name: "text_converting_query_mining_script",
      title: "Text converting query mining script",
      desc: "Goes through all search queries that converted on an account during the previous two months and creates ad groups based on the converted query text.",
    },
    {
      name: "pmax_converting_query_mining_script",
      title: "PMAX converting query mining script",
      desc: "Goes through all search queries that converted on PMAX campaigns and creates ad groups based on the converted query text.",
      options: [
        {
          name: "days_to_query",
          title: "Number of days to query:",
          placeholder: "Default 30",
        },
        {
          name: "conversions_threshold",
          title: "Conversions threshold:",
          placeholder: "Default 2",
        },
        {
          name: "impressions_threshold",
          title: "Impressions threshold:",
          placeholder: "Default 15",
        },
      ]
    },
    {
      name: "pmax_performance_reporting_script",
      title: "PMAX performance reporting script",
      desc: "Provides a detailed view of PMAX campaign performace.",
      options: [
        {
          name: "google_sheet_url",
          title: "Google Sheet URL:",
          placeholder: "https://docs.google.com/spreadsheets/...",
        }
      ]
    },
    {
      name: "em_bm_negative_overlap_script",
      title: "EM/BM negative overlap script",
      desc: "Syncs negative keyword lists throughout the account to prevent overlap.",
    },
    {
      name: "negative_dsa_sync_script",
      title: "Negative DSA sync script",
      desc: "Syncs enabled account keywords as negatives in the '[DSA]' ad group to prevent bidding on pre_targeted queries.",
    },
    {
      name: "exclude_nb_in_shopping",
      title: "Exclude Non-Brand in Shopping",
      desc: "When you split Shopping campaigns on branded and non-branded search terms, you often still get non-branded search terms in your branded Shopping campaign(s). This script automatically excludes these terms.",
    },
    {
      name: "keyword_cannibalization_script",
      title: "Keyword Cannibalization Script",
      desc: "For every ad group in the entire account, adds all keywords NOT in that ad group to be an exact match negative version to that ad group.",
    },
    // {
    //   name: "youtube_channel_excluder",
    //   title: "Exclude Foreign Language YouTube Channels",
    //   desc: "For display and video campaigns, Google is not quite so particular about targeting individual languages and video ads are often played in foreign language channels. This script identifies YouTube channels in undesired countries on which the video campaign(s) was/are played and automatically excludes them from the respective campaign.",
    // },
  ];

  const dataPulseScripts = [
    {
      name: "impressions_emergency_detector_google_ads_search",
      title: "Impressions emergency detector - Google Ads Search",
      desc: "Creates an alert and sends an email if impressions drop to 0.",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "impressions_emergency_detector_google_ads_display",
      title: "Impressions emergency detector - Google Ads Display",
      desc: "Creates an alert and sends an email if impressions drop to 0.",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "impressions_emergency_detector_google_ads_video",
      title: "Impressions emergency detector - Google Ads Video",
      desc: "Creates an alert and sends an email if impressions drop to 0.",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "impressions_emergency_detector_microsoft_ads",
      title: "Impressions emergency detector - Microsoft Ads Search",
      desc: "Creates an alert and sends an email if impressions drop to 0.",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "impressions_emergency_detector_meta_ads",
      title: "Impressions emergency detector - Meta Ads Social",
      desc: "Creates an alert and sends an email if impressions drop to 0.",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "change_tracker_google_ads",
      title: "Change tracker - Google Ads",
      desc: "Creates an alert if no changes have been recorded in the last 14 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "change_tracker_microsoft_ads",
      title: "Change tracker - Microsoft Ads",
      desc: "Creates an alert if no changes have been recorded in the last 14 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "change_tracker_meta_ads",
      title: "Change tracker - Meta Ads",
      desc: "Creates an alert if no changes have been recorded in the last 7 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        }
      ]
    },
    {
      name: "conversions_emergency_detector_google_ads",
      title: "Conversions emergency detector - Google Ads",
      desc: "Creates an alert if there are no conversions in the last 3 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "days_to_check",
          title: "Days to check:",
          placeholder: "Default 5",
        }
      ]
    },
    {
      name: "conversions_emergency_detector_microsoft_ads",
      title: "Conversions emergency detector - Microsoft Ads",
      desc: "Creates an alert if there are no conversions in the last 3 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "days_to_check",
          title: "Days to check:",
          placeholder: "Default 5",
        }
      ]
    },
    {
      name: "conversions_emergency_detector_meta_ads",
      title: "Conversions emergency detector - Meta Ads",
      desc: "Creates an alert if there are no conversions in the last 3 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "days_to_check",
          title: "Days to check:",
          placeholder: "Default 5",
        }
      ]
    },
    {
      name: "conversions_emergency_detector_tiktok_ads",
      title: "Conversions emergency detector - TikTok Ads",
      desc: "Creates an alert if there are no conversions in the last 3 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "days_to_check",
          title: "Days to check:",
          placeholder: "Default 5",
        }
      ]
    },
    {
      name: "conversions_emergency_detector_google_analytics",
      title: "Conversions emergency detector - Google Analytics",
      desc: "Creates an alert if there are no conversions in the last 3 days",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "days_to_check",
          title: "Days to check:",
          placeholder: "Default 5",
        }
      ]
    },
    {
      name: "sessions_flux_detector_google_analytics",
      title: "Sessions flux detector - Google Analytics",
      desc: "Creates an alert if sessions are down by 10% in the last 7 days compared to previous period",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "sessions_threshold",
          title: "Sessions threshold %:",
          placeholder: "Default 10%",
        }
      ]
    },
    {
      name: "clicks_flux_detector_google_search_console",
      title: "Clicks flux detector - Google Search Console",
      desc: "Creates an alert if clicks are down by 10% in the last 7 days compared to previous period",
      options: [
        {
          name: "slack_alert",
          title: "Send slack alert?",
          type: "checkbox"
        },
        {
          name: "clicks_threshold",
          title: "Clicks threshold %:",
          placeholder: "Default 10%",
        }
      ]
    },
    {
      name: "disapproved_ads_detector",
      title: "Disapproved ads detector",
      desc: "Creates an alert with a list of disapproved ads on Google ads & Microsoft.",
    },
    {
      name: "keyword_bleeder_detector",
      title: "Keyword bleeder detector",
      desc: "Emails the PPC team if a Google Ads or Microsoft keyword has spent over a specified threshold with no conversions in the past 14 days.",
      options: [
        {
          name: "threshold",
          title: "Spend threshold:",
          placeholder: "Default $350",
        },
      ],
    },
    {
      name: "url_issue_detector",
      title: "URL issue detector",
      desc: "Goes through all ads on Google Ads account and makes an alert of pages that produce unacceptable response codes.",
    },
    {
      name: "new_invite_detector",
      title: "New Invite Detector",
      desc: "Creates an alert & sends an email if a new user has been invited to a Google Ads account.",
    },
  ]

	return (
		<>
      <div className="lite-scripts">
        <div className="lite-scripts-container">
          <div className="py-4 px-3">
            <h5 className="f20 mb-4">DataPulse Scripts</h5>
            <p className="f14">
              DataPulse scripts can be used to provide useful alerts when issues occur on this account. Some require additional configuration. Please read the description of each script carefully before enabling.
            </p>
          </div>
          <div className="script-row px-3 lite-scripts-container-inner">
            <DataPulseScripts scripts={dataPulseScripts} />
          </div>
        </div>   
        <div className="lite-scripts-container">
          <div className="py-4 px-3">
            <h5 className="f20 mb-4">Google Ads Scripts</h5>
            <p className="f14">
              Google Ads scripts can be applied to your account to help manage and optimize your campaigns. These scripts can be enabled or disabled at any time. Some require additional configuration. Please read the description of each script carefully before enabling.
            </p>
            <div className="scripts-warning">
              <div className="exclaim-triangle pb-0">{exclaimTriangle}</div>
              <p className="d-inline-block f14 mb-0">
                Enabling/disabling these scripts without a thorough understanding of the function may have unintended consequences. Please proceed with caution.
              </p>
            </div>
          </div>
          <div className="script-row px-3 lite-scripts-container-inner">
            <GoogleAdsScripts scripts={googleAdsScripts} />
          </div>
        </div>
      </div>
		</>
	);
}
